import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=50ad421b"
import script from "./Widget.vue?vue&type=script&setup=true&lang=js"
export * from "./Widget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports